/*
 * @Author: ≡Christine 1204356932@qq.com
 * @Date: 2024-10-23 17:39:54
 * @LastEditors: ≡Christine 1204356932@qq.com
 * @LastEditTime: 2024-10-25 10:18:59
 * @FilePath: \management-portal\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue';
import App from './App.vue';
import install from './plugins';
import { setupRouter } from './router';
import { setupStore } from './store';
import * as Icons from '@element-plus/icons-vue';
import VueCropper from 'vue-cropper';
import 'vue-cropper/dist/index.css';
import { isHasBtn } from '@/directives/btn';
// import './styles/common.scss'; // 引入全局CSS样式

async function setupApp() {
  const app = createApp(App);

  for (const i in Icons) {
    app.component(i, Icons[i]);
  }

  // 引入裁剪画布组件
  app.use(VueCropper);
  // 插件注册&资源引入
  install(app);

  // 引入pinia
  setupStore(app);

  // 引入vue-router
  await setupRouter(app);

  //引入自定义指令文件【控制按钮显示权限】
  isHasBtn(app);

  app.mount('#app');
}

void setupApp();
